import {
  getOrderEntryForRow,
  buildOrderEntryPayload,
  createOrderEntryId,
} from '@mummssoftware/global-context/VFGlobalContext';

export { getOrderEntryForRow, buildOrderEntryPayload, createOrderEntryId };

export const resolveCarePlanForRow = (
  data: any,
  rgHash: mumms.HashedRoleGroup,
  _getPrimaryPlan?: (
    rg: mumms.HashedRoleGroup,
    roleGroupId: number | string,
  ) => any,
) => {
  const roleGroupId = data?.roleGroupId;
  if (roleGroupId == null || !rgHash) return null;
  const roleGroup = rgHash[roleGroupId.toString()];
  if (!roleGroup?.frequencies) return null;

  // Baseline row: show the real active plan at order start.
  if (data.isOrderBaseline) {
    return roleGroup.frequencies[data.id] || roleGroup.frequencies.dummy;
  }

  // Pending order rows use synthetic ids. Always use dummy as the mutable
  // scratch plan so dialog edits do not clobber the live primary frequency.
  if (data.isOrderPending || data.orderEntryId) {
    return roleGroup.frequencies.dummy || null;
  }

  return roleGroup.frequencies[data.id] || roleGroup.frequencies.dummy;
};

export const getStagedOrderEntry = (
  data: any,
  VForderData: Record<string, any>,
  VFordersMode: boolean,
  roleGroupId: number | string,
) => {
  const fromRow = getOrderEntryForRow(data, VForderData);
  if (fromRow) return fromRow;
  if (!VFordersMode) return VForderData[roleGroupId];
  return null;
};
